<template>
    <v-card outlined :loading="loading">
        <v-card-title>画像管理</v-card-title>
        <v-card-subtitle
            >{{ customer.family_name }} {{ customer.given_name }} ({{ customer.family_name_kana }}
            {{ customer.given_name_kana }})</v-card-subtitle
        >
        <v-container fluid>
            <v-row dense>
                <v-col>
                    <v-btn
                        :to="`/customer/${$route.params.id}`"
                    >カルテ
                    </v-btn>
                    <v-btn
                        :to="`/customer/history/${$route.params.id}`"
                    >経緯表
                    </v-btn>
                    <v-btn
                        v-if="customer.gender!=2"
                        :to="`/customer/matching/${$route.params.id}`"
                    >お相手選択
                    </v-btn>
                    <v-btn
                        v-else
                        :to="`/customer/matching_history/${$route.params.id}`"
                    >お相手履歴
                    </v-btn>
                    <v-btn
                        @click="openSheet(customer.sheet_id)"
                        v-if="customer.sheet_id"
                    >旧カルテを開く
                    </v-btn>
                    <v-btn
                        :to="`/customer/file-manager/${$route.params.id}`"
                    >画像管理
                    </v-btn>
                    <v-btn :class="{'pink white--text' : claimFiles.length}"
                        :to="`/customer/claim-manager/${$route.params.id}`"
                    >クレーム管理
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-card-text>
            <v-alert border="top" type="error" dense v-if="errorMessage">{{ errorMessage }}</v-alert>

            <v-container fluid>
                <v-form enctype="multipart/form-data" id="uploadForm" @submit.prevent class="mb-4">
                    <v-btn class="mr-4" type="button" @click="selectUploadFile" :disabled="files.length > 29">ファイル選択</v-btn>
                    ※保存できる画像ファイルは30個まで
                    <input
                        type="file"
                        ref="dummyInput"
                        id="file-input"
                        accept="image/png, image/jpeg, image/gif"
                        style="display: none"
                        @change="uploadFile"
                    />
                </v-form>
                <v-row dense>
                    <ImageFileCard
                        v-for="item in files"
                        :key="item.file_uuid"
                        :customerId="customerId"
                        :file="item"
                        @select="selectCard"
                        @close="deleteComfirm"
                        class="mb-2 mx-1"
                        width="130"
                        height="130"
                        :isSelected="item.file_uuid === previewImageUUID"
                    ></ImageFileCard>
                </v-row>
            </v-container>
            <v-container fluid>
                <img
                    v-if="previewImage"
                    :src="previewImage.src"
                    :data-uuid="previewImage.uuid"
                    style="max-width: 100%"
                />
            </v-container>
        </v-card-text>
        <v-dialog v-model="deleteDialog" persistent max-width="390px">
            <v-card>
                <v-card-title>選択中のファイルを削除しますか？</v-card-title>
                <v-card-text>サーバー上のファイルは消去されます。</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark class="delete" @click="deleteCard">削除</v-btn>
                    <v-btn @click="deleteComfirmClose">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import CUSTOMER from '@/consts/customer.js';
import utilDatetime from '@/utilities/datetime.js';

import ImageFileCard from '@/components/ImageFileCard.vue';

export default {
    components: {
        ImageFileCard,
    },
    title() {
        return `${this.customer.family_name} ${this.customer.given_name} (画像管理)`;
    },
    name: 'customer_files',
    mixins: [utilDatetime],
    data: () => ({
        CUSTOMER: CUSTOMER,
        customer: {
            family_name: '',
            given_name: '',
            family_name_kana: '',
            given_name_kana: '',
        },
        loading: false,
        errorMessage: '',
        files: [],
        claimFiles: [],
        previewImage: null,

        deleteDialog: false, //削除ダイアログ制御
        deleteTarget: null,
    }),
    computed: {
        customerId() {
            return this.$route.params.id;
        },
        previewImageUUID() {
            return this.previewImage?.uuid;
        },
    },
    watch: {},
    mounted() {
        this.loadInit();
    },
    methods: {
        loadInit() {
            this.$nextTick(async () => {
                const id = this.customerId;
                this.loading = true;
                try {
                    const result = await this.$axios.get(`/api/v1/customer/${id}/file-manager`);
                    this.customer = result.data.customer;
                    this.setTitle();

                    const files = await this.$axios.get(`/api/v1/customer/${id}/files`);
                    this.files = files.data;

                    const claimFiles = await this.$axios.get(`/api/v1/customer/${id}/claim-files`);
                    this.claimFiles = claimFiles.data;
                } finally {
                    this.loading = false;
                }
            });
        },
        selectUploadFile() {
            this.$refs.dummyInput.click();
        },
        async uploadFile() {
            this.loading = true;
            this.errorMessage = '';
            if (this.$refs.dummyInput.files.length > 0) {
                const file = this.$refs.dummyInput.files[0];
                const id = this.$route.params.id;
                const formData = new FormData();
                formData.append('file', file);
                var config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                };

                const res = await this.$axios.post(`/api/v1/customer/${id}/file-upload`, formData, config);

                if (res.data.status == 'OK') {
                    // リストの先頭に挿入
                    this.files.unshift(res.data.file);
                } else if (res.data.status == 'ERROR') {
                    this.errorMessage = res.data.error.message;
                }

                // 選択ファイルの状態をリセット
                document.forms['uploadForm'].reset();
            }
            this.loading = false;
        },
        selectCard(file, imageSrc) {
            this.previewImage = { uuid: file.file_uuid, src: imageSrc };
        },
        deleteComfirmClose() {
            this.deleteTarget = null;
            this.deleteDialog = false;
        },
        deleteComfirm(file) {
            this.deleteTarget = file;
            this.deleteDialog = true;
        },
        async deleteCard() {
            if (this.deleteTarget) {
                const file_uuid = this.deleteTarget.file_uuid;
                const id = this.$route.params.id;
                const res = await this.$axios.delete(`/api/v1/customer/${id}/files/${file_uuid}`, {
                    params: { hard: 1 },
                });
                if (res.data.status == 'OK') {
                    const deletedFile = res.data.file;
                    const index = this.files.findIndex((e) => e.file_uuid == deletedFile.file_uuid);
                    if (index !== -1) {
                        // 削除ファイルが選択状態であったらならば、解除
                        if (this.previewImage && deletedFile.file_uuid == this.previewImage.uuid) {
                            this.previewImage = null;
                        }
                        // クライアントで保持中のリストから消去
                        this.files.splice(index, 1);
                    }
                }
                this.deleteComfirmClose();
            }
        },
    },
};
</script>
